import { MakeCall } from './createMakeCall';

export interface ListingPhotoUploadRecord {
  url: string;
  contentType: string;
  expires: string;
  photoId: number;
  photoUuid: string;
}

const requestListingPhotoUpload = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingPhotoUploadRecord>(
    'POST',
    `/api/v2/listing/${listingId}/photos/request`,
  );
export { requestListingPhotoUpload };
